import { el } from "./dom.js";

// ARIA tabs with arrow-key navigation. Each tab's panel is an existing element.
export function createTabs({ label, tabs, selected = tabs[0].key }) {
  const list = el("div", { role: "tablist", "aria-label": label, class: "tabs" });
  const buttons = tabs.map((tab, i) => {
    const button = el("button", { type: "button", role: "tab", id: `tab-${tab.key}`, "aria-controls": `panel-${tab.key}` }, tab.label);
    tab.panel.id = `panel-${tab.key}`;
    tab.panel.setAttribute("role", "tabpanel");
    tab.panel.setAttribute("aria-labelledby", `tab-${tab.key}`);
    button.addEventListener("click", () => select(tab.key));
    button.addEventListener("keydown", (event) => {
      const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      if (!step) return;
      event.preventDefault();
      const next = (i + step + tabs.length) % tabs.length;
      select(tabs[next].key);
      buttons[next].focus();
    });
    list.append(button);
    return button;
  });
  function select(key) {
    tabs.forEach((tab, i) => {
      const on = tab.key === key;
      buttons[i].setAttribute("aria-selected", String(on));
      buttons[i].tabIndex = on ? 0 : -1;
      tab.panel.hidden = !on;
    });
  }
  select(selected);
  return { list, select };
}
